export const TOUR_STORAGE_KEY_PREFIX = 'onboarding_tour_completed';

export const TOUR_TARGET_ATTRIBUTE = 'data-tour';

export const TOUR_SPOTLIGHT_PADDING_PX = 6;

export const TourTarget = {
  Home: 'nav-home',
  History: 'nav-history',
  Punchcard: 'nav-punchcard',
  Pleas: 'nav-pleas',
  Profile: 'nav-profile',
} as const;

export type TourTarget = (typeof TourTarget)[keyof typeof TourTarget];

export interface TourStep {
  id: string;
  target: TourTarget | null;
  title: string;
  description: string;
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: 'welcome',
    target: null,
    title: 'Bem-vindo à Área do Trabalhador',
    description: 'Vamos fazer um tour rápido pelas principais funções do app. Leva menos de um minuto.',
  },
  {
    id: 'home',
    target: TourTarget.Home,
    title: 'Início',
    description: 'Acompanhe o resumo da sua jornada de hoje e acesse as ações rápidas.',
  },
  {
    id: 'punchcard',
    target: TourTarget.Punchcard,
    title: 'Registrar ponto',
    description: 'Toque aqui para registrar sua entrada, pausas e saída.',
  },
  {
    id: 'history',
    target: TourTarget.History,
    title: 'Histórico',
    description: 'Consulte suas marcações anteriores em lista ou no calendário.',
  },
  {
    id: 'pleas',
    target: TourTarget.Pleas,
    title: 'Requerimentos',
    description: 'Envie pedidos de ajuste de ponto, abonos e atestados, e acompanhe o andamento.',
  },
  {
    id: 'profile',
    target: TourTarget.Profile,
    title: 'Perfil',
    description: 'Troque o acordo ativo e ajuste preferências, notificações e privacidade.',
  },
];
